// extracted by mini-css-extract-plugin
module.exports = {"sliderWrapper":"sliderWrapper-c16fcae8","slideWrapper":"slideWrapper-46a191cf","slideInner":"slideInner-63006bb3"};